import en from './en.js';
import de from './de.js';

const langs = {
  en,
  de,
};

export default langs;
